import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default () => (
  <SvgIcon viewBox='0 0 2 10' style={{ height: 10, width: 2 }}>
    <circle
      id='Эллипс_11'
      data-name='Эллипс 11'
      cx='1'
      cy='1'
      r='1'
      fill='#fff'
    />
    <circle
      id='Эллипс_12'
      data-name='Эллипс 12'
      cx='1'
      cy='1'
      r='1'
      transform='translate(0 4)'
      fill='#fff'
    />
    <circle
      id='Эллипс_13'
      data-name='Эллипс 13'
      cx='1'
      cy='1'
      r='1'
      transform='translate(0 8)'
      fill='#fff'
    />
  </SvgIcon>
);
